var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-click-modal": false,
        width: "500px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _vm.isNcmNo
        ? _c(
            "div",
            { staticStyle: { display: "flex", "margin-top": "20px" } },
            [
              _c(
                "div",
                { staticStyle: { width: "90%", "margin-left": "10px" } },
                [
                  _c("el-input", {
                    ref: "ncmNoTextarea",
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      no: "ncmNo",
                      length: "1000"
                    },
                    on: { input: _vm.filterInput },
                    nativeOn: {
                      paste: function($event) {
                        return _vm.handlePaste($event)
                      }
                    },
                    model: {
                      value: _vm.ncmNo,
                      callback: function($$v) {
                        _vm.ncmNo = $$v
                      },
                      expression: "ncmNo"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      !_vm.isNcmNo
        ? _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticStyle: { width: "90%", "margin-left": "10px" } },
              [
                _c("cargo-advance-select", {
                  attrs: {
                    filterable: "",
                    "select-type":
                      _vm.selectTypeNames.basic_data_WoodenPackageType,
                    no: "packagingType",
                    "default-value": _vm.packagingType,
                    cache: false,
                    "tag-value": "code"
                  },
                  on: {
                    parentCallBack: function(item) {
                      return (_vm.packagingType = item.value)
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            [
              _vm.isNcmNo
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "clearSave" },
                      on: { click: _vm.clearSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearSave")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-left": "50%" } },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "dialogClose" },
                  on: { click: _vm.dialogClose }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }